var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CXPaymentLayout"},[_c('c-x-base-navigation',[_c('go-back-button',{attrs:{"slot":"left"},slot:"left"})],1),_c('div',{staticClass:"container container--padded p-t-xxl"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }